export default "__VITE_ASSET__CT3$g5AT__"